import { CircleApiContext, useCircleContext } from "lib-core"
import { createGroupOptions } from "pages/groups/create/basics/CreateGroupBasicsPage"
import React from "react"
import { useDispatch } from "react-redux"


export const CircleApiProvider = ({ children }) => {
    const { id: circleId, circle } = useCircleContext()

    const dispatch = useDispatch()

    const importDocument = () => {
        const payload: any = {}

        if (circleId) {
            payload.group = circleId
            payload.postType = "article"
        }

        dispatch({
            type: "profile/drafts/_import/public",
            payload,
        })
    }

    const createSubCircle = () => {
      createGroupOptions({
        parent: circle._id,
        privacy: circle.privacy
      })
      dispatch({
        type: 'groups/_create/basics',
        payload: {
          parent: circle._id,
          privacy: circle.privacy
        }
      })
    }



    const context = { importDocument, createSubCircle }
    return (
        <CircleApiContext.Provider value={context}>
            {children}
        </CircleApiContext.Provider>
    )
}